export const COMPANY_KEY = 'company';
